import "@/components/commons/CircularAvatar/CircularAvatar.scss";

type AppProps = {
  name?: string | undefined;
  image?: string | null | undefined;
  afterHeaderClassName?: string | undefined;
};

const Avatar = ({ name, image, afterHeaderClassName }: AppProps) => {
  let finalName = "A";
  let lastName = "";
  const blobBaseUrl = import.meta.env.REACT_APP_BLOB_BASE_URL;
  const blobToken = import.meta.env.REACT_APP_BLOB_TOEKN;

  const blobSasUrl = `${blobBaseUrl}${image}?${blobToken}`;
  const isLastName = name && name?.split(" ").length > 1;

  if (name && name.length > 1) {
    finalName = name?.split(" ")[0].slice(0, 1).toUpperCase();
    if (isLastName) {
      lastName = name?.split(" ")[1].slice(0, 1).toUpperCase();
    }
  }

  const stringToHslColor = (str: string, s: number, l: number) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const h = hash % 360;
    return "hsl(" + h + ", " + s + "%, " + l + "%)";
  };

  // let avatarBgColor = COLOR_CODES[Math.floor(Math.random() * COLOR_CODES.length)] || '#000';
  const avatarBgColor = stringToHslColor(
    name && name.length > 1 ? name : "anonymous",
    30,
    50
  );
  return (
    <div
      className={image?.length ? "" : "circularAvatarWrap size32"}
      style={{
        backgroundColor: image?.length ? "" : avatarBgColor,
        cursor: "pointer",
        minWidth: "25px",
      }}
    >
      {image?.length ? (
        <img
          className={
            afterHeaderClassName && afterHeaderClassName?.length > 0
              ? `circularAvatarWrap ${afterHeaderClassName}`
              : "circularAvatarWrap size32 mb-1"
          }
          src={blobSasUrl}
          alt="profile pic"
        />
      ) : (
        `${finalName}${lastName}`
      )}
    </div>
  );
};

export default Avatar;
